export const DEFAULT_MENTION_STYLE = {
  backgroundColor: '#F1F4F5',
  borderRadius: '10px',
  padding: '1px',
};
